import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {Minus, Plus} from '@wix/wix-ui-icons-common/on-stage'
import {useEnvironment, useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {IconButton, IconButtonThemes} from 'wix-ui-tpa/cssVars'
import {classes} from './controls.st.css'
import {ControlsProps} from './interfaces'

export const Controls = ({zoomOutDisabled, zoomInDisabled, onZoomIn, onZoomOut}: ControlsProps) => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()

  const {experiments} = useExperiments()
  const planTicketsDesignEnabled = experiments.enabled(ExperimentNames.PlanTicketsDesign)

  return (
    <div
      className={classNames(classes.controls, {
        [classes.desktopControls]: !isMobile,
        [classes.newMobileControls]: planTicketsDesignEnabled && isMobile,
      })}
    >
      <IconButton
        aria-label={t('seating_zoomIn')}
        theme={IconButtonThemes.Box}
        className={classes.control}
        disabled={zoomInDisabled}
        onClick={zoomInDisabled ? undefined : onZoomIn}
        icon={<Plus />}
      />
      <IconButton
        aria-label={t('seating_zoomOut')}
        theme={IconButtonThemes.Box}
        className={classes.control}
        disabled={zoomOutDisabled}
        onClick={zoomOutDisabled ? undefined : onZoomOut}
        icon={<Minus />}
      />
    </div>
  )
}
